import axios from 'axios';
import { getCookie } from './cookies';

const axiosInstance = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add request interceptor for CSRF token
axiosInstance.interceptors.request.use(config => {
    // Don't add CSRF token for GET requests
    if (config.method !== 'GET') {
        const csrfToken = getCookie('csrftoken');
        if (csrfToken) {
            config.headers['X-CSRFToken'] = csrfToken;
        }
    }
    // FormData requires Content-Type with boundary - let browser set it (remove json default)
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }
    return config;
});

// Add response interceptor to handle 401 Unauthorized responses
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            const url = error.config?.url || '';
            const data = error.response?.data || {};
            if (url.includes('/api/contacts-mailbox/')) {
                return Promise.reject(error);
            }
            // Access code verification required - let the view component handle it (AccessCodeModal)
            // Do NOT redirect to /mailbox?rid=... - that flow is for unauthenticated users only
            if (data.requires_verification) {
                return Promise.reject(error);
            }
            // Auth 401 - clear session and redirect to login
            localStorage.removeItem('authToken');
            localStorage.removeItem('userData');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
